import React from "react"
import {useTranslation} from "react-i18next"
import {useIonViewWillEnter} from "@ionic/react"

import {useUsers as useItems} from "../../contexts/UserContext"

import ItemList from '../../components/Users/List'
import PageList from '../common/List'
import {useAuth} from "../../contexts/AuthContext";


const PageUsersList: React.FC = () => {

    const { t } = useTranslation()
    const { userInfo: authUserInfo} = useAuth()

    const { fetchItems } = useItems()
    const { getMe } = useAuth()

    useIonViewWillEnter(() => {
        getMe().then()
    })

    const
        itemType: string     = 'Users',
        itemTypeName: string = t('users.title_list'),
        itemTypeUrl: string  = 'users'

    let showAddButton: boolean = true

    if ((authUserInfo?.user?.counts?.usersAvailable || 0) < 1) {
        showAddButton = false
    }

    return (
        <PageList
            ItemList={ItemList}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            showAddButton={showAddButton}
            fetchItems={fetchItems}
            useItems={useItems}
        />
    )
}

export default PageUsersList